module.exports = __webpack_public_path__ + "img/1.e03e2d29.jpg";